/* NK CRO — 26/09/2026
   1. Panier : produits en premier (le bandeau pack/paliers passe sous les produits), replié par défaut
   2. Code URBAN10 affiché dans le panier, avec bouton copier
   3. Pop-up de bienvenue : ne revient pas avant 5 jours
   4. Bloc livraison 3 étapes sous les moyens de paiement (fiche produit) */
(function () {
  var CODE = 'URBAN10';
  var POP_KEY = 'nkPopupDismissedV2';
  var POP_DAYS = 5;
  var START = Date.now();
  var EN = /^en/i.test(document.documentElement.lang || '');

  function ls(k, d) { try { var v = localStorage.getItem(k); return v === null ? d : v; } catch (e) { return d; } }
  function lset(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  /* ---------- 1. Bandeau pack replié par défaut ---------- */
  if (ls('nk_cro_v1', '') !== '1') {
    lset('nk_up_open', '0');
    lset('nk_cro_v1', '1');
  }
  /* Empêche l'ouverture automatique du bandeau quand un cadeau se débloque */
  lset('nk_up_touched', '1');

  /* ---------- 1. Produits en premier ---------- */
  function moveHook() {
    var drawer = document.querySelector('m-cart-drawer, .m-cart-drawer');
    if (!drawer) return;
    var footer = drawer.querySelector('.m-cart-drawer--footer, .scd__footer');
    var hook = drawer.querySelector('.m-cart-drawer--header .foxkit-cart-goal-hook, .scd__header .foxkit-cart-goal-hook');
    if (!footer || !hook) return;
    var toggle = footer.querySelector(':scope > .ukl-cart-toggle');
    if (toggle) toggle.insertAdjacentElement('afterend', hook);
    else footer.insertBefore(hook, footer.firstChild);
  }

  /* ---------- 2. Code promo ---------- */
  function copy(text, btn) {
    function done(ok) {
      btn.textContent = ok ? (EN ? 'Copied' : 'Copié') : text;
      btn.classList.toggle('is-copied', ok);
      clearTimeout(btn._t);
      btn._t = setTimeout(function () { btn.textContent = EN ? 'Copy' : 'Copier'; btn.classList.remove('is-copied'); }, 2200);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function () { done(true); }, function () { done(false); });
    } else {
      var ta = document.createElement('textarea');
      ta.value = text; ta.style.position = 'fixed'; ta.style.top = '-1000px';
      document.body.appendChild(ta); ta.select();
      var ok = false; try { ok = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta); done(ok);
    }
  }
  function addCode() {
    var footer = document.querySelector('.m-cart-drawer--footer, .scd__footer');
    if (!footer || footer.querySelector('.nk-cro-code')) return;
    var summary = footer.querySelector('.m-cart--summary, .scd__summary');
    if (!summary) return;
    var box = document.createElement('div');
    box.className = 'nk-cro-code';
    box.innerHTML = (EN
      ? '<span class="nk-cro-code__txt">10% off your first order with code <b>' + CODE + '</b>, enter it at checkout</span>'
      : '<span class="nk-cro-code__txt">-10 % sur ta 1re commande avec le code <b>' + CODE + '</b>, à saisir au paiement</span>') +
                    '<button type="button" class="nk-cro-code__btn">' + (EN ? 'Copy' : 'Copier') + '</button>';
    summary.parentNode.insertBefore(box, summary);
    box.querySelector('button').addEventListener('click', function (e) { e.preventDefault(); copy(CODE, e.currentTarget); });
  }

  /* ---------- 3. Pop-up : 5 jours ---------- */
  function extendPopup() {
    setTimeout(function () { lset(POP_KEY, String(Date.now() + POP_DAYS * 86400000)); }, 50);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#nk-pop [data-nk-pop-close]')) extendPopup();
  }, true);
  document.addEventListener('keydown', function (e) {
    var p = document.getElementById('nk-pop');
    if (e.key === 'Escape' && p && !p.hidden) extendPopup();
  });

  /* ---------- 4. Livraison 3 étapes ---------- */
  var DS = EN ? ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] : ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];
  var MS = EN ? ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] : ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
  function at(n) { var x = new Date(); x.setHours(12, 0, 0, 0); x.setDate(x.getDate() + n); return x; }
  function d(x) { return EN ? DS[x.getDay()] + ', ' + MS[x.getMonth()] + ' ' + x.getDate() : DS[x.getDay()] + ' ' + x.getDate() + ' ' + MS[x.getMonth()]; }
  function range(a, b) {
    if (EN) return d(a) + ' – ' + d(b);
    if (a.getMonth() === b.getMonth()) return DS[a.getDay()] + ' ' + a.getDate() + ' – ' + DS[b.getDay()] + ' ' + b.getDate() + ' ' + MS[b.getMonth()];
    return d(a) + ' – ' + d(b);
  }

  /* ---------- Heure limite d'expédition (heure de Paris, lundi-vendredi) ---------- */
  function paris() {
    var p = {};
    try {
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    } catch (e) { var n = new Date(); return { wd: n.getDay(), h: n.getHours(), m: n.getMinutes(), s: n.getSeconds() }; }
    var wd = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[p.weekday];
    return { wd: wd, h: parseInt(p.hour, 10) % 24, m: parseInt(p.minute, 10), s: parseInt(p.second, 10) };
  }
  /* today = expédition aujourd'hui possible ; days = nb de jours jusqu'à la prochaine expédition */
  function cutoff(hour) {
    var t = paris();
    var open = t.wd >= 1 && t.wd <= 5;
    if (open && t.h < hour) return { today: true, days: 0, hour: hour, left: ((hour - t.h) * 3600 - t.m * 60 - t.s) };
    var days = 1, wd = (t.wd + 1) % 7;
    while (wd === 0 || wd === 6) { days++; wd = (wd + 1) % 7; }
    return { today: false, days: days, hour: hour, left: 0 };
  }
  var JOURS = EN ? ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'] : ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  function startCut(el, hour) {
    var p = el.querySelector('[data-eta-cut]');
    if (!p) return;
    function paint() {
      var c = cutoff(hour);
      if (c.today) {
        var h = Math.floor(c.left / 3600), m = Math.floor((c.left % 3600) / 60), s = c.left % 60;
        var t = (h ? h + ' h ' : '') + (h ? (m < 10 ? '0' : '') + m + ' min' : m + ' min ' + (s < 10 ? '0' : '') + s + ' s');
        p.innerHTML = EN ? 'Order within <b>' + t + '</b> for <b>same-day</b> shipping' : 'Commande dans les <b>' + t + '</b> : expédition <b>aujourd’hui</b>';
      } else {
        var day = c.days === 1 ? (EN ? 'tomorrow' : 'demain') : JOURS[at(c.days).getDay()];
        p.innerHTML = EN ? 'Order now: ships <b>' + day + '</b>' : 'Commande maintenant : expédition <b>' + day + '</b>';
      }
    }
    paint();
    clearInterval(el._cut);
    el._cut = setInterval(paint, 1000);
  }
  function eta() {
    var el = document.querySelector('[data-nk-eta]');
    if (!el || el.dataset.ready) return;
    var ship = [parseInt(el.dataset.shipMin, 10) || 1, parseInt(el.dataset.shipMax, 10) || 3];
    var del = [parseInt(el.dataset.delMin, 10) || 8, parseInt(el.dataset.delMax, 10) || 12];
    var cut = cutoff(parseInt(el.dataset.cutoff, 10) || 14);
    el.querySelector('[data-eta-1]').textContent = d(at(0));
    el.querySelector('[data-eta-2]').textContent = cut.today ? ((EN ? 'today – ' : "aujourd'hui – ") + d(at(ship[1]))) : range(at(Math.max(ship[0], cut.days)), at(Math.max(ship[1], cut.days + 2)));
    startCut(el, cut.hour);
    el.querySelector('[data-eta-3]').textContent = range(at(del[0]), at(del[1]));
    var n = el.querySelector('[data-eta-note]');
    if (n) n.innerHTML = EN
      ? 'Estimated delivery between <b>' + d(at(del[0])) + '</b> and <b>' + d(at(del[1])) + '</b>'
      : 'Livraison estimée entre le <b>' + d(at(del[0])) + '</b> et le <b>' + d(at(del[1])) + '</b>';

    /* Les anciens blocs livraison de la fiche produit sont masqués */
    Array.prototype.forEach.call(document.querySelectorAll('.tracker-mini, [data-nk-dlv]'), function (x) { x.style.display = 'none'; });

    /* Sous les logos de paiement (app de badges, chargée après la page) ; à défaut après 5 s, sous Klarna */
    var badge = document.querySelector('.template-product .badgeContainer');
    var anchor = badge ? (badge.closest('.badgesContainer') || badge.parentElement) : null;
    if (!anchor && Date.now() - START < 5000) return;
    anchor = anchor ||
             document.querySelector('.template-product .nk-klarna') ||
             document.querySelector('.template-product .nk-atcr') ||
             document.querySelector('.template-product product-form');
    if (!anchor || !anchor.parentNode) return;
    anchor.parentNode.insertBefore(el, anchor.nextSibling);
    el.hidden = false;
    el.dataset.ready = '1';
  }

  /* Onglet « Livraison & Retour » de la fiche produit : même délai que partout ailleurs */
  function fixTab() {
    Array.prototype.forEach.call(document.querySelectorAll('.nk-pdt__a p, .product-tabs p, .sf-tab-content p'), function (p) {
      if (p.dataset.nkEta) return;
      if (/expédiées sous 1 à 3 jours ouvrés/.test(p.textContent) && /6 à 8 jours/.test(p.textContent)) {
        p.textContent = 'Les commandes sont expédiées sous 24 à 72 h. La livraison est ensuite estimée entre 8 et 12 jours après la commande.';
        p.dataset.nkEta = '1';
      } else if (/shipped within 1 to 3 business days/i.test(p.textContent) && /6 to 8 business days/i.test(p.textContent)) {
        p.textContent = 'Orders are shipped within 24 to 72 hours. Delivery is then estimated at 8 to 12 days after ordering.';
        p.dataset.nkEta = '1';
      }
    });
  }

  function run() { moveHook(); addCode(); eta(); fixTab(); }
  function boot() {
    run();
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 150); })
      .observe(document.body, { childList: true, subtree: true });
    document.addEventListener('nk:cart', function () { setTimeout(run, 50); });
    setTimeout(run, 5200);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
